"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLEBeaconBuilder = exports.BLEBeaconObject = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
const BLEObject_1 = require("./BLEObject");
const MACAddress_1 = require("./MACAddress");
/**
 * BLE Beacon Data Object
 */
let BLEBeaconObject = class BLEBeaconObject extends BLEObject_1.BLEObject {
    constructor(address, rawAdvertisement) {
        super(address);
        if (rawAdvertisement) {
            this.parseAdvertisement(rawAdvertisement);
        }
    }
    computeUID() {
        return this.uid;
    }
    /**
     * Get the manufacturer identifier
     * @returns {number} Manufacturer identifier
     */
    get manufacturerId() {
        return this.manufacturerData.size > 0 ? this.manufacturerData.keys().next().value : 0xffff;
    }
    /**
     * Set the manufacturer identifier
     * @param {number} value Manufacturer identifier
     */
    set manufacturerId(value) {
        // Get the current identifier
        const currentId = this.manufacturerId;
        // Get the current manufacturer data
        const currentData = this.manufacturerData.get(currentId);
        // Remove the current manufacturer
        this.manufacturerData.delete(currentId);
        // Set the new manufacturer
        this.manufacturerData.set(value, currentData);
    }
};
exports.BLEBeaconObject = BLEBeaconObject;
exports.BLEBeaconObject = BLEBeaconObject = tslib_1.__decorate([
    (0, core_1.SerializableObject)(),
    tslib_1.__metadata("design:paramtypes", [MACAddress_1.MACAddress, Uint8Array])
], BLEBeaconObject);
/**
 * BLE beacon builder
 */
class BLEBeaconBuilder {
    displayName(name) {
        this.beacon.displayName = name;
        return this;
    }
    macAddress(address) {
        if (typeof address === 'string') {
            this.beacon.address = MACAddress_1.MACAddress.fromString(address);
        }
        else {
            this.beacon.address = address;
        }
        return this;
    }
    calibratedRSSI(rssi) {
        this.beacon.calibratedRSSI = rssi;
        return this;
    }
}
exports.BLEBeaconBuilder = BLEBeaconBuilder;
//# sourceMappingURL=BLEBeaconObject.js.map